module.exports = __webpack_public_path__ + "static/media/3_My_List_Detail.1f05bb46.png";